var cube = require('./cube');

(function(cube) {

  var mix = cube.mix,
  indexOf = cube.indexOf;

  var CustEvent = cube.CustEvent = function(target, type, eventArgs) {
    this.target = target;
    this.type = type;
    mix(this, eventArgs || {});
  };

  mix(CustEvent.prototype, {
    target: null,
    currentTarget: null,
    type: null,
    returnValue: undefined,
    preventDefault: function() {
      this.returnValue = false;
    }
  });

  cube.CustEventTargetH = {

    on: function(target, sEvent, fn) {
      var cbs = (target.__custListeners && target.__custListeners[sEvent]) || cube.error("unknown event type", TypeError);
      if (indexOf(cbs, fn) > -1) {
        return false;
      }
      cbs.push(fn);
      return true;
    },

    once: function(target, sEvent, fn) {
      var cbs = (target.__custListeners && target.__custListeners[sEvent]) || cube.error("unknown event type", TypeError);
      var handler = $.proxy(function(custEvent) {
        fn.call(target, custEvent);
        cube.CustEventTargetH.un(target, sEvent, handler);
      }, this);

      cube.CustEventTargetH.on(target, sEvent, handler);
      return true;
    },

    un: function(target, sEvent, fn) {
      var cbs = (target.__custListeners && target.__custListeners[sEvent]) || cube.error("unknown event type", TypeError);
      if (fn) {
        var idx = indexOf(cbs, fn);
        if (idx < 0) {
          return false;
        }
        cbs.splice(idx, 1);
      } else {
        cbs.length = 0;
      }
      return true;

    },

    fire: function(target, sEvent, eventArgs) {
      if (sEvent instanceof CustEvent) {
        var custEvent = mix(sEvent, eventArgs);
        sEvent = sEvent.type;
      } else {
        custEvent = new CustEvent(target, sEvent, eventArgs);
      }

      var cbs = (target.__custListeners && target.__custListeners[sEvent]) || cube.error("unknown event type", TypeError);
      if (sEvent != "*") {
        cbs = cbs.concat(target.__custListeners["*"] || []);
      }

      custEvent.returnValue = undefined; //去掉本句，会导致静态CustEvent的returnValue向后污染
      custEvent.currentTarget = target;
      var obj = custEvent.currentTarget;
      if (obj && obj['on' + custEvent.type]) {
        var retDef = obj['on' + custEvent.type].call(obj, custEvent); //对于独占模式的返回值，会弱影响event.returnValue
      }

      for (var i = 0; i < cbs.length; i++) {
        cbs[i].call(obj, custEvent);
      }
      return custEvent.returnValue !== false || (retDef === false && custEvent.returnValue === undefined);
    },

    createEvents: function(target, types) {
      types = types || [];
      if (typeof types == "string") {
        types = types.split(",");
      }
      var listeners = target.__custListeners;
      if (!listeners) {
        listeners = target.__custListeners = {};
      }
      for (var i = 0; i < types.length; i++) {
        listeners[types[i]] = listeners[types[i]] || []; //可以重复create，而不影响之前的listerners.
      }
      listeners['*'] = listeners["*"] || [];
      return target;
    }
  };

}(cube));

(function(cube) {

  var Methodized = function() {};

  var Helper = {
    /**
    * 对helper的方法，进行methodize化，使其的第一个参数为this，或this[attr]。
    * <strong>methodize方法会抛弃掉helper上的非function类成员以及命名以下划线开头的成员（私有成员）</strong>
    * @method methodize
    * @static
    * @param {Helper} helper Helper对象，如DateH
    * @param {optional} attr (Optional)属性
    * @return {Object} 方法已methodize化的对象
    */
    methodize: function(helper, attr) {
      var ret = new Methodized(); //因为 methodize 之后gsetter和rwrap的行为不一样

      for (var i in helper) {
        if (typeof helper[i] == "function" && !/^_/.test(i)) {
          ret[i] = cube.methodize(helper[i], attr);
        }
      }
      return ret;
    }
  };

  cube.Helper = Helper;
}(cube));

(function(cube) {
  var mix = cube.mix;

  var CustEventTarget = cube.CustEventTarget = function() {
    this.__custListeners = {};
  };

  var methodized = cube.Helper.methodize(cube.CustEventTargetH, null, {
    on: 'operator',
    un: 'operator'
  }); //将Helper方法变成prototype方法，同时修改on/un的返回值

  mix(CustEventTarget.prototype, methodized);

  cube.CustEvent.createEvents = CustEventTarget.createEvents = function(target, types) {
    cube.CustEventTargetH.createEvents(target, types);
    return mix(target, CustEventTarget.prototype); // 尊重对象本身的on。
  };

}(cube));



//////////////////
// WEBPACK FOOTER
// ./src/js/~/cube-cust-event.js
// module id = 37
// module chunks = 1